/** @format */

import React from 'react';
import '../css/Section.css';

import libelBlender from '../images/libel-blender.png';

const Section = () => {
  
  const handleLink = (e) => {
    e.preventDefault();
    const target = e.target.getAttribute('href');
    const location = document.querySelector(target).offsetTop;
    window.scrollTo({
      left: 0,
      top: location - 80,
    });
  };

  return (
    <section className='Section'>
      <div className='Section-container container padding'>
        <div className='section-img'>
          <img src={libelBlender} alt='' />
        </div>
        <div className='section-content'>
          <div className='section-intro'>
            <div className='section-intro-subheading-wrapper'>
              <p className='section-intro-subheading'>
                Libera tu talento
              </p>
            </div>
            <h2 className='section-intro-heading'>
              Logra increíbles resultados en los primeros 15 días.
            </h2>
            <p className='section-intro-content'>
              Gracias a nuestro método de estudio podrás lograr
              grandes resultados acompañado por nuestro equipo de
              docente.
            </p>
          </div>
          <a  href='#entrenamientos' onClick={handleLink} className='section-btm'>
            Únete ahora
          </a>
        </div>
      </div>
    </section>
  );
};

export default Section;
